// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1xnGJ","controls":"styles_controls__14LzW","charLimit":"styles_charLimit__1NpDk","input":"styles_input__1wGz_","send":"styles_send__3xT9Y"};